module.exports = __webpack_public_path__ + "static/media/Error404New.8108c180.png";